// https://stackoverflow.com/a/326076
export function inIframe() {
    try {
        // browsers can block access to window.top due to same origin policy.
        // if window.top is inaccessible then we can assume the page is loaded in an iframe
        // and return true.
        // window.top should return self if not in iframe.

        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

export default { inIframe };
